import { reqLangJson, reqLangList, reqDefaultLang } from './api';
import { ref } from 'vue';
import LZString from 'lz-string';
import i18n, { LANG_ELEMENT_MAP } from './vueI18n';
import { message as elMessage } from '@yl/plugins/message';
import fsLang from './lang/fast-crud';
const i18nGlobal = i18n.global;
const _getLangJsonForLocal = () => {
  const compressed = localStorage.getItem('messageCp') || null;
  const langJsonStr = compressed
    ? LZString.decompressFromUTF16(compressed)
    : null;
  // localStorage.removeItem('messageCp') // 删除存储，节省空间
  return langJsonStr ? JSON.parse(langJsonStr) : null;
};
/**
 * 压缩存储国际化数据
 */
const _setLangJsonToLocal = () => {
  const message = i18nGlobal.getLocaleMessage(i18nGlobal.locale.value);
  // console.log('langlanglang _setLangJsonToLocal', message);
  const langJsonStr = JSON.stringify(message);
  const compressed = LZString.compressToUTF16(langJsonStr);
  localStorage.setItem('messageCp', compressed);
};
/**
 * 向vue-i18n设置翻译数据
 * @param langJson
 * @returns
 */
const setVueI18nMessage = langJson => {
  if (!langJson) {
    return;
  }
  // console.log(
  //   'langlanglang setVueI18nMessage222',
  //   i18nGlobal.locale.value,
  //   fsLang
  // );
  langJson.fs = fsLang[i18nGlobal.locale.value]?.fs;
  i18nGlobal.setLocaleMessage(i18nGlobal.locale.value, langJson);
  _setLangJsonToLocal();
  /* console.log(
    'langlanglang setVueI18nMessage2',
    i18nGlobal.locale.value,
    i18nGlobal.messages?.value
  ); */
};
/**
 * 每次重新访问系统则更新翻译数据库
 * 不含刷新当前页，用户想立即同步语言数据可以去重新登录(减少请求)
 * @param i18n
 * @returns
 */
const asyncLangJson = async () => {
  // console.log('langlanglang asyncLangJson', i18n);
  // 获取本地语言信息
  const lan = localStorage.getItem('lang');
  // 本地语种存在，则更新翻译数据
  if (lan) {
    i18n.global.locale.value = LANG_ELEMENT_MAP[lan || 'CN'];
    // 减少请求：刷新页面的方式不更新（用户想立即同步语言数据可以去重新登录）
    if (!document.referrer || location.pathname === '/login') {
      radioChange(lan || 'CN', false);
    }
  } else {
    // 获取数据库的默认语种信息
    const { data } = await reqDefaultLang();
    // 此次接口异常不影响前端运行
    radioChange(data || 'CN', false);
  }
};
const asyncLangList = async langList => {
  try {
    const { code, data } = await reqLangList();
    if (code === 1) {
      const needLang = JSON.parse(localStorage.getItem('needLangList')) || [
        'EN',
        'CN'
      ];
      let needLangList: any[] = [];
      if (data && Array.isArray(data)) {
        if (Array.isArray(needLang)) {
          data.forEach(item => {
            if (needLang.includes(item.val)) {
              needLangList.push(item);
            }
          });
        } else {
          needLangList = data;
        }
        localStorage.setItem('langList', JSON.stringify(needLangList));
      }
      langList.value = needLangList || [];
      return;
    } else {
      // console.error('asyncLangList::warn', code, msg);
      langList.value = [];
      return;
    }
  } catch (error) {
    console.error('asyncLangList::error', error);
    langList.value = [];
    return;
  }
};
/**
 * 语言改变触发
 * @param value LANG_ELEMENT_MAP的值
 * @param isReload 是否刷新页面
 * @returns
 */
const radioChange = async (value = 'CN', isReload = true) => {
  localStorage.setItem('lang', value);
  i18n.global.locale.value = LANG_ELEMENT_MAP[value];
  const { code, data, msg } = await reqLangJson(value);
  if (code !== 1) {
    elMessage(msg, { type: 'error' });
    return;
  }
  setVueI18nMessage(data);
  // elMessage('操作成功，将刷新页面');
  if (isReload) {
    setTimeout(() => window.location.reload(), 1500);
  }
};
export default function useVueI18n() {
  const langList = ref([]);
  // console.log('langlanglang useVueI18n');
  const langListStorage = JSON.parse(localStorage.getItem('langList') || '[]');
  if (
    document.referrer &&
    location.pathname !== '/login' &&
    langListStorage &&
    langListStorage.length
  ) {
    langList.value = langListStorage;
  } else {
    asyncLangList(langList);
  }
  return {
    LANG_ELEMENT_MAP,
    langList,
    _setLangJsonToLocal,
    _getLangJsonForLocal,
    radioChange,
    asyncLangList,
    asyncLangJson,
    setVueI18nMessage
  };
}
